import get from 'lodash/get'
import { createAction } from 'redux-actions'

import { actionCreators as api } from 'reduxBits/api'

const prefix = 'contentful'
export const REQUEST_FOOTER = `${prefix} request footer`
export const RECEIVE_FOOTER = `${prefix} recieve footer`
export const ERROR_FETCHING_FOOTER = `${prefix} error occuered while fetching footer`

const requestFooter = createAction(REQUEST_FOOTER)
const receiveFooter = createAction(RECEIVE_FOOTER)
const errorFetchingFooter = createAction(ERROR_FETCHING_FOOTER)

export const fetchFooter = () => async (dispatch) => {
  dispatch(requestFooter())
  try {
    const pathName = 'content/menus/footer'
    const response = await dispatch(api.fetch(pathName))
    const footerItems = get(response, 'contentCollection.items')
    if (footerItems && footerItems.length > 0) {
      dispatch(receiveFooter(footerItems))
    }
  } catch (error) {
    dispatch(errorFetchingFooter(error))
  }
}

// export const configureActionCreators = () => ({
//   fetchFooter,
// })
